module.exports = __webpack_public_path__ + "static/media/username_icon.a182d869.svg";